(function () {
  'use strict';

  angular.module('app').component('prepaymentStatusLabel', prepaymentStatusLabel());

  function prepaymentStatusLabel() {
    return {
      bindings: {
        status: '<',
      },
      controller: PrepaymentStatusLabelComponent,
      controllerAs: 'vm',
      template:
        '<span class="status-label text-{{ vm.statusClass }}">' +
        '<i class="fa fa-circle"></i> {{ vm.statusTitle }}' +
        '</span>',
    };
  }

  PrepaymentStatusLabelComponent.$inject = ['$translate'];

  function PrepaymentStatusLabelComponent($translate) {
    const vm = this;

    vm.$onChanges = function () {
      setStatusLabel();
    };

    function setStatusLabel() {
      let statusClass = 'default';
      let statusIcon = 'minus';
      let statusTitle = 'NO_PAID_PREPAYMENT';

      switch (vm.status) {
        case 'pending':
          statusClass = 'default';
          statusTitle = 'NO_PAID_PREPAYMENT';
          statusIcon = 'minus';
          break;
        case 'completed':
          statusClass = 'success';
          statusTitle = 'PAID_PREPAYMENT';
          statusIcon = 'check';
          break;
        case 'processing':
          statusClass = 'primary';
          statusTitle = 'PARTIALLY_PREPAYMENT';
          statusIcon = 'minus';
          break;
      }

      vm.statusClass = statusClass;
      vm.statusIcon = statusIcon;
      vm.statusTitle = $translate.instant(statusTitle);
    }
  }
})();
